// src/components/chat/ChatSearch.jsx
import React, { useState, useCallback } from 'react';
import { Form, InputGroup, Button, ListGroup, Spinner } from 'react-bootstrap';
import { chatAPI } from '../../services/api';
import { useDebounce } from '../../hooks/useDebounce';

const ChatSearch = ({ roomId, onResultClick }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showResults, setShowResults] = useState(false);

  const debouncedQuery = useDebounce(query, 500);

  const performSearch = useCallback(async (searchQuery) => {
    if (!searchQuery.trim() || !roomId) {
      setResults([]);
      return;
    }

    setLoading(true);
    try {
      const data = await chatAPI.searchMessages(roomId, searchQuery);
      setResults(data.messages || []);
    } catch (err) {
      console.error('Search error:', err);
      setResults([]);
    } finally {
      setLoading(false);
    }
  }, [roomId]);

  React.useEffect(() => {
    performSearch(debouncedQuery);
  }, [debouncedQuery, performSearch]);

  const handleSearch = (e) => {
    e.preventDefault();
    performSearch(query);
  };

  const handleResultClick = (message) => {
    onResultClick(message);
    setShowResults(false);
    setQuery('');
  };

  return (
    <div className="chat-search position-relative">
      {/* <Form onSubmit={handleSearch}>
        <InputGroup size="sm">
          <Form.Control
            placeholder="Поиск в чате..."
            value={query}
            onChange={(e) => {
              setQuery(e.target.value);
              setShowResults(true);
            }}
            onFocus={() => setShowResults(true)}
          />
          <Button variant="outline-primary" type="submit" disabled={loading}>
            {loading ? <Spinner animation="border" size="sm" /> : <i className="bi bi-search"></i>}
          </Button>
        </InputGroup>
      </Form> */}

      {showResults && query && (
        <div 
          className="position-absolute bg-white border rounded shadow mt-1 w-100"
          style={{ zIndex: 1050, maxHeight: '300px', overflowY: 'auto' }}
        >
          {loading ? (
            <div className="text-center p-3">
              <Spinner animation="border" size="sm" />
            </div>
          ) : results.length === 0 ? (
            <div className="text-center p-3 text-muted">
              <small>Ничего не найдено</small>
            </div>
          ) : (
            <ListGroup variant="flush">
              {results.map(msg => (
                <ListGroup.Item
                  key={msg.id}
                  action
                  onClick={() => handleResultClick(msg)}
                  className="py-2"
                >
                  <small className="text-muted d-block">
                    {new Date(msg.created_at).toLocaleString('ru-RU')}
                  </small>
                  <div className="text-truncate">{msg.content}</div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </div>
      )}
    </div>
  );
};

export default ChatSearch;